// extracted by mini-css-extract-plugin
module.exports = {"user":"MemberRow_user__1gZFC","userName":"MemberRow_userName__11v-L","groupImage":"MemberRow_groupImage__1iF3C"};